import { useState } from "react";
import FormBlock from "../../Components/Inputs/FormBlock";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../Components/LoadingAnimations/LoadingAnimations";
import instance from "../../Interceptor/api_instance";

const AddItem = ({close}) => {
    const {t} = useTranslation();
    const [formData, setFormData] = useState({
        name: null,
        sku: null,
        description: null,
        unit: null,
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const update = (e) => {
        const {name, value} = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const response = await instance.post('safety/inventory-part', formData);
            if (response.status === 201) {
                window.location.reload();
            }
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    }
    
    return (
        <div className="page-mask page-mask-animation">
            <div className="white-cont">
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <h2 className="global-h2">
                    Add Item
                </h2>
            <FormBlock label={t("yard-tables.table-columns.name")} 
            name={"name"}
            value={formData.name}
            update={update}
            isRequired={true}
            type={"text"}
            />
                        <FormBlock label={t("yard-tables.table-columns.code")} 
            name={"sku"}
            value={formData.sku}
            update={update}
            isRequired={true}
            type={"text"}
            />
                        <FormBlock label={t("yard-tables.table-columns.description")} 
            name={"description"}
            value={formData.description}
            update={update}
            isRequired={false}
            type={"text"}
            />
                        <FormBlock label={t("yard-tables.table-columns.unit")} 
            name={"unit"}
            value={formData.unit}
            update={update}
            isRequired={true}
            type={"text"}
            placeholder={"ea,box,etc."}
            />
            {isLoading ? <Spinner/> : 
            (<div className="full-cont">
                <button className="change-pwd-btn all-btn" type="submit">{t("buttons.submit")}</button>
                <button className="cancel-btn all-btn" onClick={close} type="button">{t("buttons.cancel")}</button>
                </div>)}
                </form>
            </div>

        </div>
    )
}

export default AddItem;